<script setup lang="ts">
import { ORDER_STATUS } from "core/interfaces";

import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { useOrdersStore } from "~/stores/orders";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { ordersConfirmRefund } = useModalStore();
const ordersStore = useOrdersStore();

const submitOrderRefund = async () => {
	await ordersStore.patchById(ordersConfirmRefund.order.id, {
		status: ORDER_STATUS.CANCELED
	});

	ordersConfirmRefund.closeModal();

	if (route.name === "orders") {
		ordersStore.getAll({}, ordersStore.recentGetAllQuery);
	} else {
		ordersStore.currentOrder = await ordersStore.getById(ordersConfirmRefund.order.id);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.ORDERS.CONFIRM_REFUND.alert.title"),
		description: t("COMPONENTS.ORDERS.CONFIRM_REFUND.alert.description", { nonce: ordersConfirmRefund.order.id }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ORDERS.CONFIRM_REFUND.title')"
		:description="$t('COMPONENTS.ORDERS.CONFIRM_REFUND.description', {nonce: ordersConfirmRefund.order.id})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesRefund')"
		@close="ordersConfirmRefund.closeModal"
		@submit="submitOrderRefund"
	/>
</template>
